export default __webpack_public_path__ + "static/media/c006-5.5ef76920.gif";